import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { SubscriptionState } from "explorer/reducers/subscription";
import { AdvanceState } from "explorer/reducers/adiantamentos";
import { ArtistState } from "explorer/reducers/artistas";
import { DistributionStatusEnum } from "shared/enums/DistributionStatusEnum";
import { SubscriptionType } from "shared/enums/SubscriptionType";
import { CashAdvanceAvailableEnum } from "shared/enums/CashAdvanceAvailable";

export type UseSubscriptionReturn = {
  currentPlan?: SubscriptionPlan;
  eligibleUpgrade: boolean;
  nextUpgrade: SubscriptionPlan | null;
  trial: boolean;
  paidPlan: boolean;
};

export enum SubscriptionPlan {
  START = "START",
  PREMIUM = "PREMIUM",
  DISTRIBUTION = "DISTRIBUTION",
  LABEL_SERVICES = "LABEL_SERVICES",
}

export const subscriptionLabel = {
  [SubscriptionPlan.START]: "components.Subscription.Start",
  [SubscriptionPlan.PREMIUM]: "components.Subscription.Premium",
  [SubscriptionPlan.DISTRIBUTION]: "components.Subscription.Distribution",
  [SubscriptionPlan.LABEL_SERVICES]: "components.Subscription.LabelServices",
};

const useSubscription = (): UseSubscriptionReturn => {
  const [currentPlan, setCurrentPlan] = useState<SubscriptionPlan>();
  const [eligibleUpgrade, setEligibleUpgrade] = useState<boolean>(false);
  const [nextUpgrade, setNextUpgrade] = useState<SubscriptionPlan | null>(null);
  const [trial, setTrial] = useState<boolean>(false);
  const [paidPlan, setPaidPlan] = useState<boolean>(false);

  // console.log(currentPlan, eligibleUpgrade, nextUpgrade);
  const { subscriptionInfo } = useSelector(
    (state: SubscriptionState) => state.subscription
  );
  const { cashAdvanceAvailable } = useSelector(
    (state: AdvanceState) => state.advances
  );

  const { userArtist } = useSelector((state: ArtistState) => state.artists);

  useEffect(() => {
    let currentPlanComputed: SubscriptionPlan | undefined = undefined;
    let isEligibleForUpgrade = false;
    let nextUpgradePlan: SubscriptionPlan | null = null;
    if (!userArtist?.stage) return;
    if (!userArtist) {
      setCurrentPlan(currentPlanComputed);
      setEligibleUpgrade(isEligibleForUpgrade);
      setNextUpgrade(nextUpgradePlan);
      return;
    }

    if (
      userArtist.cashAdvanceSigned ||
      userArtist.distribution?.status === DistributionStatusEnum.Signed
    ) {
      currentPlanComputed = SubscriptionPlan.DISTRIBUTION;
    }

    if (
      (subscriptionInfo?.type === SubscriptionType.Trial ||
        subscriptionInfo?.type === SubscriptionType.Paid) &&
      !currentPlanComputed
    ) {
      currentPlanComputed = SubscriptionPlan.PREMIUM;
    }

    if (
      subscriptionInfo?.type === SubscriptionType.Free &&
      !currentPlanComputed
    ) {
      currentPlanComputed = SubscriptionPlan.START;
      isEligibleForUpgrade = true;
      nextUpgradePlan = SubscriptionPlan.PREMIUM;
    }

    // if (currentPlanComputed === SubscriptionPlan.PREMIUM) {
    if (
      cashAdvanceAvailable === CashAdvanceAvailableEnum.Available ||
      userArtist.distribution?.available
    ) {
      isEligibleForUpgrade = true;
      nextUpgradePlan = SubscriptionPlan.DISTRIBUTION;
    }
    // }

    if (userArtist.stage && userArtist.stage >= 7) {
      isEligibleForUpgrade = true;
      nextUpgradePlan = SubscriptionPlan.LABEL_SERVICES;
    }

    console.log(setPaidPlan, setTrial);
    // setCurrentPlan(currentPlanComputed);
    // setEligibleUpgrade(isEligibleForUpgrade);
    // setNextUpgrade(nextUpgradePlan);
    // setTrial(subscriptionInfo?.type === SubscriptionType.Trial);
    // setPaidPlan(subscriptionInfo?.type === SubscriptionType.Paid);
  }, [userArtist, subscriptionInfo?.type, cashAdvanceAvailable]);

  return {
    currentPlan,
    eligibleUpgrade,
    nextUpgrade,
    trial,
    paidPlan,
  };
};

export default useSubscription;
